import Vue from 'vue';
import randomString from '@/helpers/randomString';
import moment from '@/helpers/momentz';

import { updateField } from 'vuex-map-fields';

export default {
  CTRL_PANEL_DISPLAYED_SET(state, isDisplayed) {
    state.ctrlPanelDisplayed = isDisplayed;
  },
  CTRL_ACTIVE_SECTION_SET(state, section) {
    state.activeSection = section;
  },
  ADD_CONTACT(state, data) {
    state.addContact = data.contact_uid;
  },
  DELETE_CONTACT(state, data) {
    state.deleteContact = data;
  },
  CONTACT_DATA_SET(state, data) {
    state.contactData = data;
    state.contactDataIsLoading = false;
  },
  CONTACT_DATA_IS_LOADING_SET(state, isLoading) {
    state.contactDataIsLoading = isLoading;
  },
  NOTES_VIEW_ACTIVE_FOR_CONTACT(state, id) {
    state.notesViewActiveForContact = id;
  },
  CLEAR_CONTACT_NOTES(state) {
    state.notes.data = [];
    state.notes.meta = {};
  },
  ADD_CONTACT_NOTES(state, data) {
    state.notes.data = [...state.notes.data, ...data.data];
    // Sometimes last page request is finished before the previous pagebundleRenderer.renderToStream// TODO make sure this doesn't happen on rewrite. Next page should load a few moments after the view is updated.
    if (
      !state.notes.meta.current_page ||
      state.notes.meta.current_page < data.meta.current_page
    ) {
      state.notes.meta = data.meta;
    }
  },
  ADD_NOTE(state, payload) {
    state.notes.data.push({
      animationKey: randomString(),
      content: '',
      created_by: payload.createdBy,
      created_at: moment().unix(),
    });
  },
  SILENT_ADD_NOTE(state, payload) {
    state.notes.data.push({
      animationKey: randomString(),
      ...payload,
    });
  },
  UPDATE_NOTE(state, payload) {
    const noteToEdit = state.notes.data.find(note => note.id === payload.noteId);
    if (noteToEdit) {
      noteToEdit.content = payload.data.content;
    }
  },
  DELETE_NOTE(state, index) {
    state.notes.data.splice(index, 1);
  },
  UNDELETE_NOTE(state, payload) {
    state.notes.data.splice(payload.index, 0, payload.noteBkp);
  },
  SAVE_NOTE(state, payload) {
    state.notes.data[payload.index].content = payload.content;
  },
  SET_NOTE_ID(state, payload) {
    Vue.set(state.notes.data[payload.index], 'id', payload.id);
  },
  LOADING_NOTES(state, status) {
    state.loadingNotes = status;
  },
  SET_ACTIVE_DETAILS_SECTION(state, section) {
    state.activeDetailsSection = section;
  },

  API_ERROR(state, payload) {
    if (payload) {
      state.apiError = payload;
    }
  },
  updateField,
};
